import { render, staticRenderFns } from "./ActAdmin.vue?vue&type=template&id=c4dd7514&scoped=true"
import script from "./ActAdmin.vue?vue&type=script&lang=js"
export * from "./ActAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dd7514",
  null
  
)

export default component.exports